import { useState } from 'react';
import { X, Check } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function NotifyModal({ product, onClose }) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email.includes('@')) return;
    setLoading(true);
    try {
      await fetch(`${BACKEND_URL}/api/notify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, product }),
      });
    } catch (_) {}
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0, zIndex: 1000,
          background: 'rgba(45,32,24,0.45)',
          backdropFilter: 'blur(5px)',
          animation: 'backdrop-in 0.25s ease both',
        }}
      />

      {/* Card */}
      <div
        data-testid="notify-modal"
        style={{
          position: 'fixed',
          top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1001,
          width: 'min(420px, calc(100vw - 32px))',
          backgroundColor: '#FAF5EF',
          borderRadius: '20px',
          padding: '36px',
          boxShadow: '0 24px 60px rgba(45,32,24,0.2)',
          animation: 'modal-in-desktop 0.3s cubic-bezier(0.34,1.3,0.64,1) both',
        }}
      >
        {/* Close */}
        <button
          onClick={onClose}
          data-testid="notify-modal-close"
          style={{ position: 'absolute', top: '18px', right: '20px', background: 'none', border: 'none', cursor: 'pointer', color: '#9E8E7E' }}
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {!submitted ? (
          <>
            <span style={{ fontFamily: 'Graphik, sans-serif', fontWeight: 700, fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase', color: '#B85C3A', display: 'block', marginBottom: '12px' }}>
              Coming Soon
            </span>
            <h2 style={{ fontFamily: 'Canela, serif', fontWeight: 500, fontSize: '26px', color: '#2D2018', marginBottom: '10px', letterSpacing: '-0.01em' }}>
              Be the first to know.
            </h2>
            <p style={{ fontFamily: 'Graphik, sans-serif', fontWeight: 500, fontSize: '14px', color: '#6B5D50', lineHeight: 1.65, marginBottom: '24px' }}>
              <strong style={{ color: '#2D2018' }}>{product}</strong> is launching soon. Drop your email and we&apos;ll notify you first.
            </p>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              data-testid="notify-email-input"
              onKeyDown={e => e.key === 'Enter' && handleSubmit()}
              style={{
                width: '100%', padding: '13px 16px', marginBottom: '14px',
                fontFamily: 'Graphik, sans-serif', fontWeight: 500, fontSize: '15px', color: '#2D2018',
                backgroundColor: '#F5EEE8',
                border: '1.5px solid rgba(92,36,36,0.15)',
                borderRadius: '10px', outline: 'none', boxSizing: 'border-box',
                transition: 'border-color 0.2s ease',
              }}
              onFocus={e => e.target.style.borderColor = '#5C2424'}
              onBlur={e => e.target.style.borderColor = 'rgba(92,36,36,0.15)'}
            />
            <button
              onClick={handleSubmit}
              disabled={!email.includes('@') || loading}
              data-testid="notify-submit-btn"
              className="btn-primary"
              style={{ width: '100%', textAlign: 'center', opacity: email.includes('@') ? 1 : 0.45, cursor: email.includes('@') ? 'pointer' : 'not-allowed', padding: '14px' }}
            >
              {loading ? 'Saving…' : 'Notify Me →'}
            </button>
          </>
        ) : (
          <div style={{ textAlign: 'center', paddingTop: '8px' }}>
            <div style={{ width: '60px', height: '60px', borderRadius: '50%', backgroundColor: 'rgba(92,36,36,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <Check size={26} color="#5C2424" strokeWidth={2} />
            </div>
            <h2 style={{ fontFamily: 'Canela, serif', fontWeight: 500, fontSize: '26px', color: '#2D2018', marginBottom: '10px' }}>
              You&apos;re on the list!
            </h2>
            <p style={{ fontFamily: 'Graphik, sans-serif', fontWeight: 500, fontSize: '14px', color: '#6B5D50', lineHeight: 1.6, marginBottom: '24px' }}>
              We&apos;ll email you as soon as <strong style={{ color: '#2D2018' }}>{product}</strong> is ready to book.
            </p>
            <button onClick={onClose} data-testid="notify-done-btn" className="btn-outline" style={{ padding: '12px 32px' }}>
              Close
            </button>
          </div>
        )}
      </div>
    </>
  );
}
